<template>
  <Layou class="px_1" header mian footer>
    <template v-slot:header>
      <el-row class="logo_header" style="display: block;">
        <el-col  class="logo_header_box">
            <div class="logo_img">
              <el-image :src="logo"></el-image>
            </div>
            <div  class="titile_logo"><a href="/">MxDraw云图帮助</a></div>
        </el-col>
      </el-row>
    </template>
    <template v-slot:main>
      <div class="main">
        <div class="fiex">
          <div class="login hidden-sm-and-down">
            <el-image :src="src"></el-image>
          </div>
          <div class="card">
            <el-card shadow="always">
              <el-tabs
                v-model="activeName"
                type="card"
                @tab-click="handleClick"
                :stretch="true"
                class="user_tabs"
              >
                <el-tab-pane label="账号登录" name="first">
                  <div class="user_login">
                    <div class="input_text inpup_first">
                      <el-input
                        placeholder="请输入手机号"
                        v-model="username"
                        maxlength="11"
                        @focus="clearUserInput"
                      ></el-input>
                    </div>
                    <div class="input_text">
                      <el-input
                        placeholder="请输入密码"
                        v-model="password"
                        show-password
                        maxlength="25"
                        @focus="clearUserInput"
                      ></el-input>
                    </div>

                    <div>
                      <el-input
                        placeholder="请输入验证码"
                        v-model="useryzcode"
                        maxlength="4"
                        @focus="clearUserInput"
                      >
                        <template slot="append">
                          <div
                            v-html="tpCodeUser"
                            class="tpcode_div"
                            @click="cutTpCode_user"
                            title="看不清?点击换一张"
                          ></div>
                        </template>
                      </el-input>
                    </div>

                    <div class="input_text input_err_tips" id="userLoginErr">{{errTipsUser}}</div>

                    <div class="tips">
                      <el-button type="text" @click="dialogTableVisible = true">
                        <span style="float: left">
                          <router-link to="register">新用户注册</router-link>
                        </span>
                        <span style="float: right" class="forgetpwd">
                          <router-link to="resetpwd">忘记账号密码？</router-link>
                        </span>
                      </el-button>
                    </div>
                    <el-button type="primary" @click="userLogin">登录</el-button>
                  </div>
                </el-tab-pane>
                <el-tab-pane label="短信快捷登录" name="second">
                  <div class="mobile_login">
                    <div class="input_text inpup_first">
                      <el-input
                        placeholder="请输入手机号"
                        v-model="mobile"
                        maxlength="11"
                        @focus="clearMobileInput"
                      >
                        <template slot="prepend">+86</template>
                      </el-input>
                    </div>
                    <div class="input_text">
                      <el-input
                        placeholder="请输入验证码"
                        v-model="phoneyzcode"
                        maxlength="4"
                        @focus="clearMobileInput"
                      >
                        <template slot="append">
                          <div
                            v-html="tpCodeMobile"
                            class="tpcode_div"
                            @click="cutTpCode_mobile"
                            title="看不清?点击换一张"
                          ></div>
                        </template>
                      </el-input>
                    </div>
                    <div>
                      <el-input
                        placeholder="请输入短信验证码"
                        v-model="phoneCode"
                        maxlength="4"
                        @focus="clearMobileInput"
                      >
                        <template slot="append">
                          <span v-show="show" @click="getCode" class="get_Code">获取验证码</span>
                          <span v-show="!show" class="count get_Code">重新获取({{count}})</span>
                          <!-- 获取验证码 -->
                        </template>
                      </el-input>
                    </div>
                    <div class="input_text input_err_tips" id="mobileLoginErr">{{errTipsMobile}}</div>
                    <div class="tips">
                      <el-button type="text" @click="dialogTableVisible = true">
                        <span style="float: left">
                          <router-link to="register">新用户注册</router-link>
                        </span>
                        <span style="float: right" class="forgetpwd">
                          <router-link to="resetpwd">忘记账号密码？</router-link>
                        </span>
                      </el-button>
                    </div>
                    <el-button type="primary" @click="mobileLogin">登录</el-button>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </el-card>
          </div>
        </div>
      </div>
    </template>

    <template v-slot:footer height="120px">
      <div class="logo_footer logo_footer_btm">
        成都梦想凯德科技有限公司 版权所有 Copyright @ 2016 All Rights Reserved
        <span style="margin-left:10px;">
          <a href="http://www.miitbeian.gov.cn/" style="color:#999;">蜀ICP备15011727号</a>
        </span>
        <div class="link" style=" font-size: 14px;">
          友情链接 |
          <a href="http://www.ddooo.com" target="_blank">多多软件站</a> |
          <a href="http://www.crsky.com" target="_blank">非凡软件站</a> |
          <a href="http://xiazai.zol.com.cn" target="_blank">ZOL应用下载</a> |
          <a href="http://mydown.yesky.com" target="_blank">天极下载</a>
        </div>
      </div>
    </template>
  </Layou>
</template>

<script>
import Layou from "../components/Layou/index.vue";
export default {
  name: "login",
  components: {
    Layou,
  },
  data() {
    return {
      src: require("../assets/img/logo.png"),
      logo: require("../assets/img/logo2.png"),
      username: "",
      password: "",
      useryzcode: "",

      mobile: "",
      phoneyzcode: "",
      phoneCode: "",

      activeName: "first",
      tpCodeUser: "",
      tpCodeMobile: "",
      show: true,
      count: "",
      timer: null,
      errTipsUser: "",
      errTipsMobile: "",
    };
  },
  mounted: function () {
    this.get();
  },
  methods: {
    get: function () {
      var that = this;
      //发送get请求
      this.$api.get("/login?u=" + that.$route.query.u).then(
        function (res) {
          that.tpCodeUser = res.data.code_user;
          that.tpCodeMobile = res.data.code_mobile;
          if (res.data.u != "undefined" && res.data.u != undefined) {
            that.username = res.data.u;
          }
        },
        function () {
          that.$message.error("服务器异常，请稍后重试！");
        }
      );
    },
    handleClick(tab, event) {
      if (tab.label === "登录") this.$router.push("login");
    },
    clearUserInput() {
      //关闭账号密码登录错误提示
      document.getElementById("userLoginErr").style.visibility = "hidden";
    },
    clearMobileInput() {
      //关闭短信验证码登录错误提示
      document.getElementById("mobileLoginErr").style.visibility = "hidden";
    },
    getCode() {
      var that = this;
      const TIME_COUNT = 60;
      var mobile = that.mobile;
      var yzcode = that.phoneyzcode;
      if (!/^1[3456789]\d{9}$/.test(mobile)) {
        that.errTipsMobile = "请输入正确的手机号";
        document.getElementById("mobileLoginErr").style.visibility = "";
        return;
      }
      that.$api.post("/check/tpCodeMobile", { yzcode: yzcode }).then(
        function (res) {
          if (res.data.code == "success") {
            if (!that.timer) {
              that.count = TIME_COUNT;
              that.show = false;
              that.timer = setInterval(() => {
                if (that.count > 0 && that.count <= TIME_COUNT) {
                  that.count--;
                } else {
                  that.show = true;
                  clearInterval(that.timer);
                  that.timer = null;
                }
              }, 1000);
            }
            that.$api.post("/send/code", { uname: mobile, type: "login" }).then(
              function (res) {
                if (res.data.code == 0) {
                  that.errTipsMobile = "验证码已发送至手机";
                  document.getElementById("mobileLoginErr").style.visibility =
                    "";
                } else {
                  that.errTipsMobile = "获取验证码失败，请稍后重试";
                  document.getElementById("mobileLoginErr").style.visibility =
                    "";
                }
              },
              function () {
                that.$message.error("服务器异常，请稍后重试！");
              }
            );
          } else {
            that.errTipsMobile = res.data.msg;
            document.getElementById("mobileLoginErr").style.visibility = "";
          }
        },
        function () {
          that.$message.error("服务器异常，请稍后重试！");
        }
      );
    },
    cutTpCode_user() {
      var that = this;
      //切换验证码
      this.$api.post("/tpCode").then(
        function (res) {
          that.tpCodeUser = res.data.yzm;
        },
        function () {
          that.$message.error("服务器异常，请稍后重试！");
        }
      );
    },
    cutTpCode_mobile() {
      var that = this;
      //切换验证码
      this.$api.post("/tpCode2").then(
        function (res) {
          that.tpCodeMobile = res.data.yzm;
        },
        function () {
          that.$message.error("服务器异常，请稍后重试！");
        }
      );
    },
    userLogin() {
      var that = this;
      var username = that.username;
      var password = that.password;
      var yzmcode = that.useryzcode;
      if (!username) {
        that.errTipsUser = "请输入用户名(手机号)";
        document.getElementById("userLoginErr").style.visibility = "";
        return;
      }

      if (!password) {
        that.errTipsUser = "请输入密码";
        document.getElementById("userLoginErr").style.visibility = "";
        return;
      }
      if (!yzmcode) {
        that.errTipsUser = "请输入验证码";
        document.getElementById("userLoginErr").style.visibility = "";
        return;
      }
      this.$api
        .post("/userLogin", {
          username: username,
          password: password,
          yzmcode: yzmcode,
        })
        .then(
          function (res) {
            if (res.data.code == "success") {
              that.$router.push("/mywork");
            } else {
              that.errTipsUser = res.data.msg;
              document.getElementById("userLoginErr").style.visibility = "";
            }
          },
          function () {
            that.$message.error("服务器异常，请稍后重试！");
          }
        );
    },
    mobileLogin() {
      var that = this;
      var uname = that.mobile;
      var verify_code = that.phoneCode;
      if (!uname) {
        that.errTipsMobile = "请输入手机号";
        document.getElementById("mobileLoginErr").style.visibility = "";
        return;
      }
      if (!verify_code) {
        that.errTipsMobile = "请输入短信验证码";
        document.getElementById("mobileLoginErr").style.visibility = "";
        return;
      }

      this.$api
        .post("/mobileLogin", { uname: uname, verify_code: verify_code })
        .then(
          function (res) {
            if (res.data.code == "success") {
              that.$router.push("/mywork");
            } else {
              that.errTipsMobile = res.data.msg;
              document.getElementById("mobileLoginErr").style.visibility = "";
            }
          },
          function () {
            that.$message.error("服务器异常，请稍后重试！");
          }
        );
    },
  },
};
</script>

<style scoped>
.logo_header,
.logo_footer {
  /*background-color: #B3C0D1;*/
  color: #333;
  text-align: center;
  line-height: 60px;
  border-bottom: 1px solid #e6e6e6;
}
.logo_footer_btm {
  border-bottom: 1px solid #e6e6e6;
}
.logo_header {
  width: 100%;
  height: 57px;
  line-height: 57px;
  background: #fff;
  box-shadow: 0 2px 6px 0 rgba(9, 31, 111, 0.13);
}
.logo_header_box {
  display: block;
    position: relative;
    height: 57px;
    width: 1250px;
    margin: 0px 450px;
}
.card {
  float: left;
  width: 100%;
  max-width: 420px;
}

.input_text {
  /*width: 380px;*/
  /*margin-left: 50px;*/
  margin-bottom: 30px;
}
.el-button {
  width: 360px;
}
.el-tabs__item {
  font-size: 20px;
}
.inpup_first {
  margin-top: 20px;
}
.fiex {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom:200px;
}
.main {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.el-footer .link a {
  color: #999;
  text-decoration: none;
}
.tips {
  margin-bottom: 15px;
}

.tips a {
  color: #409eff;
  text-decoration: none;
}
.user_tabs {
  margin-top: 10px;
}
.input_tpcode.el-input.el-input-group__append {
  padding: 0;
}
.tpcode_div {
  width: 110px;
  height: 40px;
  margin: -20px;
  cursor: pointer;
}
.get_Code {
  cursor: pointer;
}

.input_err_tips {
  margin-bottom: 5px;
  text-align: left;
  display: block;
  color: red;
  font-size: 14px;
  height: 15px;
}

  .titile_logo{
      line-height: 60px;
      float: left;
      cursor: pointer;
  }

  .titile_logo a{
    color: #333;
    text-decoration:none;
     font-weight: 600;
    font-size: 1.3rem;
  }

  .logo_img {
  width: 60px;
  height: 60px;
  line-height: 40px;
  float: left;
  display: flex;
  justify-content: center;
  align-items: center;
}

@media screen and (max-width: 1500px) {
  .logo_header_box {
  display: block;
    position: relative;
    height: 57px;
    width: 1250px;
    margin: 0px 200px;
}
}

@media screen and (max-width: 760px) {
  .logo_header_box {
  display: block;
    position: relative;
    height: 57px;
    margin: 0
}
.forgetpwd{
  padding-right: 20px;
}
}
</style>



// WEBPACK FOOTER //
// src/components/login.vue